import { DatePicker, Descriptions } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  createLevelUpData,
  getLevelUpCourses,
  getLevelUpData1,
  getLevelUpData2,
  getLevelUpResult,
  toggleLevelUpDataOpen,
  updateLevelUpData,
} from '../../../api/semesters.api';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import config from '../../../lib/config';
import {
  IGetLevelUpCourses,
  IGetLevelUpData1,
  IGetLevelUpData2,
  IGetLevelUpResult,
} from '../../../models/semesters.model';
import { RootState } from '../../../store/rootReducer';
import Button from '../../Button';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import ConfirmModal from '../../modals/ConfirmModal';
import SelectLevel from '../../SelectLevel';
import LevelUpListModal from './modals/LevelUpListModal';
import ScoreStaticsModal from './modals/scoreStatics/ScoreStaticsModal';
import { SEMESTER_TYPE } from '../../../constans';

interface IProps {
  semesterCode: string;
  semesterStartDate: string;
  semesterEndDate?: string;
  selSemesterType?: string;
}

const Level: FC<IProps> = ({ semesterCode, semesterStartDate, semesterEndDate, selSemesterType }) => {
  const { t, i18n } = useTranslation();
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  const { infoNotification, successNotification } = useNotification();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetLevelUpCourses>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetLevelUpData1>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios<IGetLevelUpData2>();
  const {
    data: res4,
    isLoading: isLoading4,
    error: error4,
    execute: execute4,
  } = useAxios<IGetLevelUpResult>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();
  const {
    data: submitRes2,
    isLoading: submitIsLoading2,
    error: submitError2,
    execute: submitExecute2,
  } = useAxios();

  const [courseCode, setCourseCode] = useState<number>();
  const [courses, setCourses] = useState<any>([]);
  const [levelUpCode, setLevelUpCode] = useState<number>();
  const [standardScore, setStandardScore] = useState(
    config.levelUpDefault.standardScore,
  );
  const [nextCourseCode, setNextCourseCode] = useState<string>();
  const [weights, setWeights] = useState<any>(config.levelUpDefault.weights);
  const [levelUpListVisible, setLevelUpListVisible] = useState(false);
  const [scoreStaticsVisible, setScoreStaticsVisible] = useState(false);
  const [confirmToggleVisible, setConfirmToggleVisible] = useState(false);
  const [confirmSubmitVisible, setConfirmSubmitVisible] = useState(false);
  const [resultCount, setResultCount] = useState<any>({
    totalCount: null,
    levelUpResultCount: null,
    campusLevelUpResultCount: null,
  });
  const [subTab, setSubTab] = useState('');

  useEffect(() => {
    if (semesterCode) {
      setCourseCode(undefined);
      execute(getLevelUpCourses(semesterCode));
    }
  }, [semesterCode]);

  useEffect(() => {
    if (res?.data && courseCode && semesterStartDate) {
      const data = res.data.find((item) => item.courseCode === courseCode);
      if (data) {
        const _courses = _.cloneDeep(data.detailCourseList);
        if(selSemesterType === SEMESTER_TYPE.SPECIAL_CLASS) {
          _courses.forEach((item: any) => {
            item.evaluationSrtDate = moment(semesterStartDate).format('YYYYMMDD');
            item.evaluationEndDate = moment(semesterEndDate).format('YYYYMMDD');
          });
        } else {
          _courses.forEach((item: any) => {
            item.evaluationSrtDate = moment(semesterStartDate).format('YYYYMMDD');
            item.evaluationEndDate = moment(serverDate).format('YYYYMMDD');
          });
        }

        setCourses(_courses);
        setLevelUpCode(undefined);
        setStandardScore(config.levelUpDefault.standardScore);
        setNextCourseCode(undefined);
        setWeights(config.levelUpDefault.weights);
        setResultCount({
          totalCount: null,
          levelUpResultCount: null,
          campusLevelUpResultCount: null,
        });
      }
    }
  }, [courseCode, semesterStartDate]);

  useEffect(() => {
    if (semesterCode && courseCode) {
      doGetLevelUpData1();
    }
  }, [semesterCode, courseCode]);

  useEffect(() => {
    if (res2?.data && !isLoading2) {
      if (res2.data.levelUpCode) {
        setLevelUpCode(res2.data.levelUpCode);
        execute3(getLevelUpData2(res2.data.levelUpCode));
        execute4(getLevelUpResult(res2.data.levelUpCode));
      }

      const _courses = _.cloneDeep(courses);
      _courses.forEach((item: any) => {
        const data = res2.data.detailCourseDateInfo?.find(
          (item2: any) => item2.courseDetailCode === item.courseDetailCode,
        );
        if (data) {
          item.evaluationSrtDate = data.evaluationSrtDate;
          item.evaluationEndDate = data.evaluationEndDate;
        }
      });
      setCourses(_courses);
      setStandardScore(String(Number(res2.data.standardScore)));
      if (res2.data.nextCourseCode) {
        setNextCourseCode(String(res2.data.nextCourseCode));
      }
    }
  }, [res2, isLoading2]);

  useEffect(() => {
    if (res3?.data && !isLoading3) {
      setWeights(_.cloneDeep(res3.data?.scoreWeightInfo));
    }
  }, [res3, isLoading3]);

  useEffect(() => {
    if (res4?.data && !isLoading4) {
      setResultCount({
        totalCount: res4.data.totalCount,
        levelUpResultCount: res4.data.levelUpResultCount,
        campusLevelUpResultCount: res4.data.campusLevelUpResultCount,
      });
    }
  }, [res4, isLoading4]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      doGetLevelUpData1();
      successNotification(t('common.message.save1'));
      setConfirmSubmitVisible(false);
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    if (submitRes2 && !submitIsLoading2) {
      successNotification(
        `${t('program.semester.message30')}${
          res2?.data?.openYn === 'Y'
            ? t('program.semester.message28')
            : t('program.semester.message29')
        }${t('program.semester.message31')}`,
      );
      doGetLevelUpData1();
    }
  }, [submitRes2, submitIsLoading2]);

  const doGetLevelUpData1 = () => {
    if (semesterCode && courseCode) {
      execute2(getLevelUpData1(semesterCode, courseCode));
    }
  };

  const onSetCourses = (index: number, key: string, value: string) => {
    const _courses = [...courses];
    _courses[index][key] = value;
    setCourses(_courses);
  };

  const onSetWeights = (index: number, key: string, value: string) => {
    const _weights = [...weights];
    _weights[index][key] = value;
    setWeights(_weights);
  };

  //20240510 소수점 1자리 체크
  const isCheckStandardScore = (statndarScore: number) => {
    console.log(`standardScore : ${standardScore}`);
    const regExp = /^([1-9]{1}\d{0,1}|0{1})(\.{1}\d{0,1})?$/g;
    if (regExp.test(standardScore)) {
      return true;
    } else {
      return false;
    }
  };

  const onSubmit = () => {
    for (let i = 0; i < courses.length; i++) {
      if (!courses[i].evaluationSrtDate || !courses[i].evaluationEndDate) {
        return infoNotification(t('program.semester.message32'));
      }
    }
    //20240510 standardScore 점수 100점 이상시 return
    if (Number(standardScore) > 100) {
      return infoNotification(t('program.semester.message36'));
    }
    //20240510 standardScore 점수 소수점 및 소수점 아래 한글자만 있는지 체크
    if (!isCheckStandardScore(Number(standardScore))) {
      return infoNotification(t('program.semester.message37'));
    }

    if (standardScore === '') {
      return infoNotification(t('program.semester.message33'));
    }
    if (!nextCourseCode) {
      return infoNotification(t('program.semester.message34'));
    }
    for (let i = 0; i < weights.length; i++) {
      if (
        weights[i].mt1ScoreWeight === '' ||
        weights[i].mt2ScoreWeight === '' ||
        weights[i].ttScoreWeight === '' ||
        weights[i].icoachingScoreWeight === '' ||
        weights[i].elearningScoreWeight === ''
      ) {
        return infoNotification(t('program.semester.message35'));
      }
    }

    const req: any = {
      semesterCode,
      courseCode,
      standardScore,
      nextCourseCode,
      basicInfo: courses,
      scoreWeightInfo: weights,
    };
    console.log('req', req);
    levelUpCode
      ? submitExecute(updateLevelUpData(levelUpCode, req))
      : submitExecute(createLevelUpData(req));
  };

  const onToggleOpen = () => {
    if (!levelUpCode) return;
    submitExecute2(
      toggleLevelUpDataOpen(levelUpCode, {
        openYn: res2?.data?.openYn === 'Y' ? 'N' : 'Y',
      }),
    );
  };

  return (
    <div>
      {(isLoading ||
        isLoading2 ||
        isLoading3 ||
        isLoading4 ||
        submitIsLoading ||
        submitIsLoading2) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={error4} />
      <ErrorResponse error={submitError} />
      <ErrorResponse error={submitError2} />

      <div className="tab-seme__content">
        <div className="comm-tab__button">
          {res?.data?.map((item, _i) => (
            <button
              type="button"
              className={`btn-item ${subTab === _i.toString() ? 'active' : ''}`}
              onClick={() => {
                setCourseCode(item.courseCode);
                setSubTab(_i.toString());
              }}
              key={_i}
            >
              {item.courseName}
            </button>
          ))}
        </div>
        {courseCode && (
          <div>
            <div className="comm-bx__between">
              <h3 className="sub-title">{t('program.semester.title8')}</h3>
            </div>
            <div className="comm-table__area rowType">
              <Descriptions
                bordered
                column={2}
                size="small"
                labelStyle={{ textAlign: 'center', width: '25%' }}
                contentStyle={{ width: '25%' }}
              >
                {courses.map((item: any, index: number) => (
                  <Descriptions.Item label={item.courseDetailName} span={2}>
                    <div className="flex">
                      <div className="v-line mr-2">
                        {t('program.semester.column35')}
                      </div>
                      <div className="date-picker__area">
                        <DatePicker
                          value={
                            courses[index].evaluationSrtDate
                              ? moment(courses[index].evaluationSrtDate)
                              : undefined
                          }
                          onChange={(e) => {
                            if (e === null) {
                              onSetCourses(index, 'evaluationSrtDate', '');
                            } else {
                              onSetCourses(
                                index,
                                'evaluationSrtDate',
                                moment(e).format('YYYYMMDD'),
                              );
                            }
                          }}
                          disabled={selSemesterType === SEMESTER_TYPE.SPECIAL_CLASS}
                        />
                      </div>
                      <div className="v-line ml-4 mr-2">
                        {t('program.semester.column13')}
                      </div>
                      <div className="date-picker__area">
                        <DatePicker
                          value={
                            courses[index].evaluationEndDate
                              ? moment(courses[index].evaluationEndDate)
                              : undefined
                          }
                          onChange={(e) => {
                            if (e === null) {
                              onSetCourses(index, 'evaluationEndDate', '');
                            } else {
                              onSetCourses(
                                index,
                                'evaluationEndDate',
                                moment(e).format('YYYYMMDD'),
                              );
                            }
                          }}
                          disabled={selSemesterType === SEMESTER_TYPE.SPECIAL_CLASS}
                        />
                      </div>
                    </div>
                  </Descriptions.Item>
                ))}
                <Descriptions.Item label={t('program.semester.column36')}>
                  <input
                    type="number"
                    className="form-control w-150p"
                    value={standardScore}
                    onChange={(e) => setStandardScore(e.target.value)}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t('program.semester.column37')}>
                  {/* <div className="w-100"> */}
                  <div>
                    <SelectLevel
                      value={nextCourseCode}
                      onChange={(value) => setNextCourseCode(value)}
                    />
                  </div>
                </Descriptions.Item>
              </Descriptions>
            </div>

            <div className="comm-bx__between">
              <h3 className="sub-title">{t('program.semester.title9')}</h3>
            </div>
            <div className="comm-table__area">
              <table>
                <thead>
                  <tr>
                    <th>Case</th>
                    <th>MT1</th>
                    <th>MT2</th>
                    <th>TT</th>
                    <th>iCoaching</th>
                    <th>e-Learning</th>
                  </tr>
                </thead>
                <tbody>
                  {config.levelUpDefault.labels.map((label, index) => (
                    <tr key={index}>
                      <td>{label}</td>
                      <td>
                        <input
                          type="number"
                          className="form-control w-100p"
                          value={weights[index]?.mt1ScoreWeight}
                          onChange={(e) =>
                            onSetWeights(
                              index,
                              'mt1ScoreWeight',
                              e.target.value,
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control w-100p"
                          value={weights[index]?.mt2ScoreWeight}
                          onChange={(e) =>
                            onSetWeights(
                              index,
                              'mt2ScoreWeight',
                              e.target.value,
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control w-100p"
                          value={weights[index]?.ttScoreWeight}
                          onChange={(e) =>
                            onSetWeights(index, 'ttScoreWeight', e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control w-100p"
                          value={weights[index]?.icoachingScoreWeight}
                          onChange={(e) =>
                            onSetWeights(
                              index,
                              'icoachingScoreWeight',
                              e.target.value,
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control w-100p"
                          value={weights[index]?.elearningScoreWeight}
                          onChange={(e) =>
                            onSetWeights(
                              index,
                              'elearningScoreWeight',
                              e.target.value,
                            )
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="comm-bx__between">
              <h3 className="sub-title">{t('program.semester.title10')}</h3>
            </div>
            <div className='comm-table__area rowType'>
              <Descriptions
                bordered
                column={3}
                size="small"
                labelStyle={{ textAlign: 'center', width: '16.6%' }}
              >
                <Descriptions.Item label={t('program.semester.column39')}>
                  {resultCount.totalCount}
                </Descriptions.Item>
                <Descriptions.Item label={t('program.semester.column40')}>
                  {resultCount.levelUpResultCount}
                </Descriptions.Item>
                <Descriptions.Item label={t('program.semester.column41')}>
                  {resultCount.campusLevelUpResultCount}
                </Descriptions.Item>
              </Descriptions>
            </div>

            <div className="comm-bx__between">
              <div className="comm-btn__area">
                <Button
                  className="btn-basic pink-line"
                  onClick={() => setLevelUpListVisible(true)}
                  text={t('program.semester.button9')}
                  disabled={!levelUpCode}
                />
                <Button
                  className="btn-basic pink-line"
                  onClick={() => setScoreStaticsVisible(true)}
                  text={t('program.semester.text14')}
                  // disabled={!levelUpCode}
                />
              </div>
              <div className="comm-btn__area">
                <Button
                  className="btn-basic pink-line"
                  onClick={() => setConfirmToggleVisible(true)}
                  text={
                    res2?.data?.openYn === 'Y'
                      ? t('program.semester.message28')
                      : t('program.semester.message29')
                  }
                  disabled={!levelUpCode}
                />
                <Button
                  className="btn-basic pink"
                  onClick={() => setConfirmSubmitVisible(true)}
                  text={t('common.button.save')}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {levelUpListVisible && (
        <LevelUpListModal
          visible={levelUpListVisible}
          setVisible={setLevelUpListVisible}
          levelUpCode={levelUpCode}
          semesterCode={semesterCode}
          courseCode={courseCode}
        />
      )}
      {
        /**
         * 점수통게 모달 작성 */
        scoreStaticsVisible && (
          <ScoreStaticsModal
            visible={scoreStaticsVisible}
            setVisible={setScoreStaticsVisible}
            levelUpCode={levelUpCode}
            semesterCode={semesterCode}
          />
        )
      }
      {confirmToggleVisible && (
        <ConfirmModal
          visible={confirmToggleVisible}
          setVisible={setConfirmToggleVisible}
          onConfirm={onToggleOpen}
          titleText={`${
            res2?.data?.openYn === 'Y'
              ? t('program.semester.message28')
              : t('program.semester.message29')
          } ${t('program.semester.title11')}`}
          messageText={
            i18n.language === 'ko'
              ? `${t('program.semester.text10')} ${
                  res2?.data?.openYn === 'Y'
                    ? t('program.semester.message28')
                    : t('program.semester.message29')
                }${t('program.semester.text11')}`
              : `${
                  res2?.data?.openYn === 'Y'
                    ? t('program.semester.message28')
                    : t('program.semester.message29')
                } ${t('program.semester.text10')} ${t(
                  'program.semester.text11',
                )}`
          }
          confirmText={t('common.option.yes')}
          cancelText={t('common.option.no')}
        />
      )}
      {confirmSubmitVisible && (
        <ConfirmModal
          visible={confirmSubmitVisible}
          setVisible={setConfirmSubmitVisible}
          onConfirm={onSubmit}
          titleText={t('program.semester.title12')}
          messageText={t('program.semester.text12')}
          confirmText={t('common.option.yes')}
          cancelText={t('common.option.no')}
        />
      )}
    </div>
  );
};

export default Level;
